// @ts-nocheck
import { Controller } from "@hotwired/stimulus";
import { enter, leave, toggle } from "el-transition";

export default class extends Controller {
  static targets = ["trigger"];

  toggleFlyout(event) {
    const flyout = event.currentTarget.nextElementSibling;
    toggle(flyout);
  }
}
